import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/no-data.png'


const _withScopeId = n => (_pushScopeId("data-v-c9fd3fea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "SbomVulImpactChart-container" }
const _hoisted_2 = { class: "SbomVulImpactChart-main" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "header-title" }
const _hoisted_5 = { class: "switch" }
const _hoisted_6 = { class: "graphChart" }
const _hoisted_7 = { class: "legendBox" }
const _hoisted_8 = { class: "chartTableBox" }
const _hoisted_9 = { class: "chart" }
const _hoisted_10 = { class: "table sbom-table" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "no-data" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "暂无相关内容")
], -1))
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_SbomEchart = _resolveComponent("SbomEchart")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.vulId) + " 漏洞影响范围", 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_switch, {
            modelValue: _ctx.isEchart,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isEchart) = $event)),
            size: "small",
            "active-text": "图",
            "inactive-text": "表",
            style: {"--el-switch-on-color":"#13ce66","--el-switch-off-color":"#ff4949"}
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.graphColors, (item, itemIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: itemIndex,
              class: "item"
            }, [
              _createElementVNode("i", {
                class: "dot",
                style: _normalizeStyle({ backgroundColor: item.color })
              }, null, 4),
              _createTextVNode(" " + _toDisplayString(item.label), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("div", _hoisted_9, [
            _createVNode(_component_SbomEchart, {
              chartId: "sbomVulnerability",
              chartType: "graph",
              dataList: _ctx.chartData,
              onEchartsClick: _ctx.echartsClick
            }, null, 8, ["dataList", "onEchartsClick"])
          ], 512), [
            [_vShow, _ctx.isEchart]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_select, {
              modelValue: _ctx.checked,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checked) = $event)),
              placeholder: "请选择",
              onChange: _ctx.handleSelect,
              style: {"margin-bottom":"10px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.graphColors, (item, itemIndex) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (item.prop !== 'vulnerability')
                      ? (_openBlock(), _createBlock(_component_el_option, {
                          key: itemIndex,
                          label: item.label,
                          value: item.prop
                        }, null, 8, ["label", "value"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"]),
            _createVNode(_component_el_table, {
              data: _ctx.chartTableData,
              stripe: "",
              border: "",
              "highlight-current-row": "",
              "scrollbar-always-on": ""
            }, {
              empty: _withCtx(() => [
                _hoisted_11
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "漏洞关联组件purl",
                  "show-overflow-tooltip": ""
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("span", {
                      class: "link",
                      onClick: ($event: any) => (
                      _ctx.goDetailPath(scope.row.elementId, scope.row.nodeType)
                    )
                    }, _toDisplayString(scope.row.label), 9, _hoisted_12)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ], 512), [
            [_vShow, !_ctx.isEchart]
          ])
        ])
      ])
    ])
  ]))
}